import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Platform-aware modifier label for keyboard-shortcut hints ("⌥1" vs "Alt+1").
export const IS_MAC =
  typeof navigator !== 'undefined' && /Mac/i.test(navigator.platform || navigator.userAgent);
export const ALT_KEY_LABEL = IS_MAC ? '⌥' : 'Alt+';
// Platform-aware Cmd/Ctrl label for shortcut hints ("⌘L" vs "Ctrl+L").
export const MOD_KEY_LABEL = IS_MAC ? '⌘' : 'Ctrl+';
